import React, { type JSX } from 'react';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import { IBusinessCollectionMenuItem } from '../Utils/BusinessCollectionMenuUtils';
import { DisabledType } from '../../BusinessDataForm/Utils/BusinessDataFormUtils';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import {
  useIsMediumBreakpoint,
  useIsSmallBreakpoint,
} from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';

interface IProps {
  menuItem: IBusinessCollectionMenuItem;
  onClick: () => void;
  label: string;
  disabled: DisabledType;
  disabledReason: string | JSX.Element | JSX.Element[] | undefined;
}

const HighlightedBusinessCollectionMenuItem: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const isSmall = useIsSmallBreakpoint();
  const isMedium = useIsMediumBreakpoint();
  return isSmall ? (
    <EDIconButton
      color="primary"
      icon={
        props.menuItem.iconType ? (
          <EDIcon
            color={props.disabled ? 'disabled' : 'primary'}
            iconType={props.menuItem.iconType}
          />
        ) : null
      }
      margin="none"
      onClick={props.onClick}
      padding="dense"
      tooltip={props.label}
      disabled={Boolean(props.disabled)}
      disabledReason={props.disabledReason}
    />
  ) : isMedium ? (
    <EDButton
      label={'Lägg till'}
      onClick={props.onClick}
      disabled={Boolean(props.disabled)}
      disabledReason={props.disabledReason}
      icon={
        props.menuItem.iconType ? (
          <EDIcon
            color={props.disabled ? 'disabled' : 'primary'}
            iconType={props.menuItem.iconType}
          />
        ) : null
      }
      tooltip={props.label}
      flat
      primary
      size="medium"
    />
  ) : (
    <EDButton
      label={props.label}
      onClick={props.onClick}
      disabled={Boolean(props.disabled)}
      disabledReason={props.disabledReason}
      icon={
        props.menuItem.iconType ? (
          <EDIcon
            color={props.disabled ? 'disabled' : 'primary'}
            iconType={props.menuItem.iconType}
          />
        ) : null
      }
      tooltip={props.label}
      flat
      primary
      size="medium"
    />
  );
};

export default HighlightedBusinessCollectionMenuItem;
